<template>
  <div class="menu disp-scroll"
  :class="{'custom-menu': !isMenuMiniSize, 'custom-menu-min': isMenuMiniSize}">
    <!-- モーダル画面 -->
    <div style="display: flex;">
      <!-- アラートダイアログ -->
      <ModalAlertDialog
        :isAlertDialogOpen="isAlertDialogOpen"
        :alertData="alertData"
        @alertResult="alertResult"
      />
    </div>
    <b-modal :active.sync="isReleaseMarkdown" @close="isReleaseMarkdown=false">
      <ReleaseMarkdown />
    </b-modal>
    <b-modal :active.sync="isViewMarkdown" @close="isViewMarkdown=false">
      <ViewMarkdown v-bind:sendnowID="sendID()"
        :sendvalue="sendValue()"
        :sendnowDate="sendDate()"
        :sendreadDate="sendMessage()"
        :sendtitle="sendTitle()"
        @contentsMessage="contentsMethod"/>
    </b-modal>
    <ModalRequestHelp />
    <RoboCreate
      :isCardModalActive="isShowRoboCreate"
      @cancel="showRoboCreate"
      :PCTRLLOG="CTRLLOG"
    />
    <RoboCreateRequest
      :isCardModalActive="isShowRoboCreateRequest"
      @cancel="showRoboCreateRequest"
      :PCTRLLOG="CTRLLOG"
    />
    <b-modal width="680px" :active.sync="isShowBilling">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            プランにつきまして
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              ご利用ありがとうございます。
              現在無料のトライアル期間を過ぎた状態でご使用になっております。
              現状のままご使用になられますとアカウントが停止になる場合もございます。
              下記よりプランの選択画面へ移動していただき、早急にプランをお選びいただけますようお願い致します。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isShowBilling=false">閉じる</a>
          <a class="card-footer-item" @click="isShowBilling=false; $router.push('/client/setting/billing?view=plan')">プラン選択画面へ</a>
        </footer>
      </div>
    </b-modal>
    <b-modal width="680px" :active.sync="isShowBillingNoFeature">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            こちらの機能をご使用になられたい場合に
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              スタンダードもしくはライトプランで使用が可能です。
              ご利用されたい場合は下記プラン選択画面にてご変更いただけますよう
              お願い致します。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isShowBillingNoFeature=false">閉じる</a>
          <a class="card-footer-item" @click="isShowBillingNoFeature=false; $router.push('/client/setting/billing?view=plan')">プラン選択画面へ</a>
        </footer>
      </div>
    </b-modal>
    <ul class="menu-list">
      <div v-if="!isMenuMiniSize" style="height: 51px;">
        <img src="@/assets/logo.svg" style="margin-left: -6px; height: 51px; width: auto; object-fit: cover; max-height: none;">
      </div>
      <div v-else style="height: 51px;">
        <img src="@/assets/whitemonster60.png" style="margin-left: 10px; margin-top: 10px; margin-bottom: 11px; height: 20px; width: auto; object-fit: cover; max-height: none;">
      </div>
      <li class="list-info" id="list-info" @mouseover="mouseoverUserInfo" @mouseleave="mouseleaveUserInfo">
        <router-link to="/client/setting/personal" :class="{'click-menu': $route.path === '/'}" class="hover-menu">
          <img class="account-img" style="max-height: none;" :src="profileImage">
          <p v-if="!isMenuMiniSize" style="font-size: 13px; color: #ffffff;">{{user.username}}</p>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListUserInfoFlg">
          <li @click="releaseMarkdownModal()" v-if="user.isAgent && !menuActive">
            <p class="link">
              通知発信
            </p>
          </li>
          <li @click="viewMarkdownModal()" v-if="!menuActive">
            <p class="link">
              通知
            </p>
          </li>
          <li @click="setRHModal()">
            <p class="link">
              お問合わせ
            </p>
          </li>
          <li @click="logout()">
            <p class="link">
              ログアウト
            </p>
          </li>
          <li v-if="user.isAgent && isMenuMiniSize">
            <!-- スーパーユーザーの場合 -->
            <div>
              <div style="height: 55px; display: flex; align-items: center; position: relative;">
                <b-autocomplete
                  v-model="companySearchText"
                  :data="filteredCompanyListForAutocomplete"
                  field="name"
                  :clearable="true"
                  @select="option => currentCompany = option ? option.id : null"
                  placeholder="会社名を検索または選択"
                  icon="magnify"
                  size="is-small"
                  style="max-width: 140px;"
                  :open-on-focus="true"
                  :dropdown-position="'bottom'">
                  <template slot-scope="props">
                    <div class="media" style="padding: 5px;">
                      <div class="media-content" style="overflow: visible; white-space: normal; word-wrap: break-word;">
                        <span>{{ props.option.name }}</span>
                      </div>
                    </div>
                  </template>
                  <template slot="empty">
                    <span style="padding: 10px;">該当する会社が見つかりません</span>
                  </template>
                </b-autocomplete>
                <button @click="updateUserCompany(currentCompany)"
                  class="button is-primary is-small"
                  style="font-size: 12px; margin-left: 5px;"
                  :disabled="!currentCompany">
                  移動
                </button>
              </div>
              <!-- 現在の会社名を表示 -->
              <div style="margin-top: 5px; padding: 0 8px;">
                <p style="font-size: 11px; color: #333;">
                  現在: {{(currentCompanyName || user.companyName).length > 10 ? (currentCompanyName || user.companyName).substring(0, 10) + '...' : (currentCompanyName || user.companyName)}}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </li>
      <!-- 稼働中のロボアイコン表示 -->
      <li class="list-direct robo-visual-item"
          v-if="lockedRobots.length > 0"
          @mouseenter="handleRoboMouseEnter($event)"
          @mouseleave="handleRoboMouseLeave">

        <!-- メインアイコン（既存部分を維持） -->
        <a class="dropdown-item"
           @click.prevent="moveToLockedRoboScenario"
           style="cursor: pointer;">
          <div class="robo-icon-container">
            <img :src="getRoboIconUrl(lockedRobots[0])"
                 @error="handleIconError"
                 class="robo-icon"
                 alt="稼働中のロボ"
                 loading="lazy">
            <span v-if="lockedRobots.length > 1" class="robo-count-badge">
              {{ lockedRobots.length }}
            </span>
          </div>
          <!-- 単一ロボ時のみツールチップ表示 -->
          <b-tooltip v-if="lockedRobots.length === 1"
                     :label="getLockedRoboNames(lockedRobots)"
                     position="is-right"
                     multilined>
            <span>稼働中のロボ</span>
          </b-tooltip>
          <span v-else>稼働中のロボ</span>
        </a>

        <!-- グリッド表示ポップアップ（新規追加） -->
        <transition name="robo-popup-fade" appear>
          <div v-if="roboGridVisible && lockedRobots.length > 1"
               class="robo-grid-popup"
               :class="{'robo-grid-popup-mini': isMenuMiniSize}"
               :style="popupPosition"
               @mouseenter="cancelHideTimer"
               @mouseleave="handlePopupMouseLeave">

          <div class="robo-grid-container"
               :class="getGridClass">

            <!-- 各ロボアイコン（最大9台） -->
            <div v-for="robo in displayedRobos"
                 :key="robo.scenario_name"
                 class="robo-grid-item"
                 @click.stop="moveToSpecificRobo(robo)"
                 :title="robo.name">
              <img :src="getRoboIconUrl(robo)"
                   @error="handleIconError"
                   class="robo-grid-icon"
                   :alt="robo.name">
              <div class="robo-grid-name">{{ truncateName(robo.name || 'ロボ', 8) }}</div>
            </div>

            <!-- 10台以上の場合の「全て表示」ボタン -->
            <div v-if="hasMoreRobos"
                 class="robo-grid-item more-item"
                 @click.stop="navigateToRoboList"
                 title="在籍ロボ一覧を表示">
              <div class="more-icon">
                <span class="mdi mdi-dots-horizontal mdi-36px"></span>
              </div>
              <div class="robo-grid-name">
                全て表示<br>
                <span class="more-count">(+{{ moreRoboCount }}台)</span>
              </div>
            </div>
          </div>
        </div>
        </transition>
      </li>
      <li class="list-direct" @mouseover="mouseleaveReset" v-if="!isMenuMiniSize">
        <!-- スーパーユーザーの場合 -->
        <div v-if="user.isAgent">
          <div style="height: 30px; display: flex; align-items: center;">
            <b-autocomplete
              v-model="companySearchText"
              :data="filteredCompanyListForAutocomplete"
              field="name"
              :clearable="true"
              @select="option => currentCompany = option ? option.id : null"
              placeholder="会社名を検索または選択"
              icon="magnify"
              size="is-small"
              style="max-width: 140px; flex: 1;"
              :open-on-focus="true"
              :dropdown-position="'bottom'">
              <template slot-scope="props">
                <div class="media" style="padding: 5px;">
                  <div class="media-content" style="overflow: visible; white-space: normal; word-wrap: break-word;">
                    <span>{{ props.option.name }}</span>
                  </div>
                </div>
              </template>
              <template slot="empty">
                <span style="padding: 10px;">該当する会社が見つかりません</span>
              </template>
            </b-autocomplete>
            <button @click="updateUserCompany(currentCompany)"
              class="button is-primary is-small"
              style="font-size: 12px; margin-left: 5px;"
              :disabled="!currentCompany">
              移動
            </button>
          </div>
          <!-- 現在の会社名を表示 -->
          <div style="margin-top: 5px; padding: 0 8px;">
            <p style="font-size: 12px; color: #ffffff; opacity: 0.8;">
              <span class="mdi mdi-office-building mdi-18px" style="margin-right: 4px;"></span>
              {{currentCompanyName || user.companyName}}
            </p>
          </div>
        </div>
        <!-- 一般ユーザーの場合 -->
        <div style="height: 30px;" v-else>
          <p style="padding: 8px; font-size: 13px; color: #ffffff;">{{user.companyName}}</p>
        </div>
      </li>
      <li v-else>
        <!-- ミニサイズメニューの時 -->
        <div v-if="user.isAgent" style="height: 30px; padding: 5px;">
          <b-tooltip :label="`現在の会社: ${currentCompanyName || user.companyName}`" position="is-right">
            <span class="mdi mdi-office-building mdi-24px mdi-light"></span>
          </b-tooltip>
        </div>
        <div v-else style="height: 30px;"></div>
      </li>
      <li @click="isMenuMinimumSize()" @mouseover="mouseleaveReset">
        <p style="cursor: hand; cursor:pointer; margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;">
          <span v-if="!isMenuMiniSize" class="mdi mdi-format-horizontal-align-left mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-else class="mdi mdi-format-horizontal-align-right mdi-24px mdi-light" style="margin-right: 0px;"></span>
        </p>
      </li>
      <!--  ロボ社員メニュー  -->
      <template v-if="shouldShowMenusAsAccordion">
        <!-- Accordion header for ロボ社員メニュー -->
        <li class="list-direct accordion-header secondary" @click="toggleRoboMenu" @mouseover="mouseleaveReset">
          <div class="hover-menu" style="cursor: pointer; display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; align-items: center;">
              <span v-if="!isMenuMiniSize" style="color: white; font-weight: 600; font-size: 13px;">ロボ社員メニュー</span>
            </div>
            <span v-if="!isMenuMiniSize" class="mdi mdi-light" :class="isRoboMenuExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" style="color: white;"></span>
          </div>
        </li>
        <!-- Accordion content for ロボ社員メニュー -->
        <template v-if="shouldShowRoboMenuItems">
          <li class="list-robo-employment" id="list-robo-employment" @mouseover="mouseoverListRoboCreate"  @mouseleave="mouseleaveListRoboCreate">
            <router-link to="/client/robo_employment" :class="{'click-menu': $route.path === '/client/robo_employment'}" class="hover-menu">
              <span class="mdi mdi-factory mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ロボ新規作成</span>
            </router-link>
            <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListRoboCreateFlg">
              <li>
                <router-link to="/client/robo_employment">
                  ロボ社員を選ぶ
                </router-link>
              </li>
              <li @click="showRoboCreateRequest(true)">
                <p class="link">
                  サポートに相談
                </p>
              </li>
              <li @click="showRoboCreate(true)">
                <p class="link">
                  作成
                </p>
              </li>
            </ul>
          </li>
          <li class="list-robo" id="list-robo" @mouseover="mouseoverListRobo"  @mouseleave="mouseleaveListRobo">
            <router-link to="/client/chatbot?view=sitemap" :class="{'click-menu': $route.path === '/client/chatbot?view=sitemap'}" class="hover-menu">
              <span class="mdi mdi-robot mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ロボ社員</span>
            </router-link>
            <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListRoboFlg">
              <li>
                <router-link to="/client/chatbot?view=sitemap">
                  ロボ出勤
                </router-link>
              </li>
              <li>
                <router-link to="/client/robo_list">
                  在籍ロボ一覧
                </router-link>
              </li>
              <li @click="moveToScenarioTop()" v-if="chatbots.length > 0 && !isCBLoading">
                <p class="link">
                  ロボ編集
                </p>
              </li>
              <li v-if="isCBLoading">
                <p class="link">
                  ロボ編集
                </p>
              </li>
            </ul>
          </li>
          <li class="list-direct" @mouseover="mouseleaveReset">
            <a :class="{'click-menu': $route.path === '/client/directtalk', 'startup': user.billing === 0}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0">
              <span class="mdi mdi-comment-processing-outline mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ロボ会話履歴</span>
            </a>
            <router-link to="/client/directtalk" :class="{'click-menu': $route.path === '/client/directtalk'}" class="hover-menu" v-else>
              <span class="mdi mdi-comment-processing-outline mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ロボ会話履歴</span>
            </router-link>
          </li>
          <li @mouseover="mouseleaveReset">
            <router-link to="/client/setting/app_icon" :class="{'click-menu': $route.path === '/client/setting/app_icon'}" class="hover-menu">
              <span class="mdi mdi-home mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ホームページ設定</span>
            </router-link>
          </li>
        </template>
      </template>
      
      <!-- Original structure for super users -->
      <template v-else>
        <li class="list-direct secondary" @mouseover="mouseleaveReset">
          <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">ロボ社員メニュー</span></p>
          <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        </li>
        <li class="list-robo-employment" id="list-robo-employment" @mouseover="mouseoverListRoboCreate"  @mouseleave="mouseleaveListRoboCreate">
          <router-link to="/client/robo_employment" :class="{'click-menu': $route.path === '/client/robo_employment'}" class="hover-menu">
            <span class="mdi mdi-factory mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ロボ新規作成</span>
          </router-link>
          <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListRoboCreateFlg">
            <li>
              <router-link to="/client/robo_employment">
                ロボ社員を選ぶ
              </router-link>
            </li>
            <li @click="showRoboCreateRequest(true)">
              <p class="link">
                サポートに相談
              </p>
            </li>
            <li @click="showRoboCreate(true)">
              <p class="link">
                作成
              </p>
            </li>
          </ul>
        </li>
        <li class="list-robo" id="list-robo" @mouseover="mouseoverListRobo"  @mouseleave="mouseleaveListRobo">
          <router-link to="/client/chatbot?view=sitemap" :class="{'click-menu': $route.path === '/client/chatbot?view=sitemap'}" class="hover-menu">
            <span class="mdi mdi-robot mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ロボ社員</span>
          </router-link>
          <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListRoboFlg">
            <li>
              <router-link to="/client/chatbot?view=sitemap">
                ロボ出勤
              </router-link>
            </li>
            <li>
              <router-link to="/client/robo_list">
                在籍ロボ一覧
              </router-link>
            </li>
            <li @click="moveToScenarioTop()" v-if="chatbots.length > 0 && !isCBLoading">
              <p class="link">
                ロボ編集
              </p>
            </li>
            <li v-if="isCBLoading">
              <p class="link">
                ロボ編集
              </p>
            </li>
          </ul>
        </li>
        <li class="list-direct" @mouseover="mouseleaveReset">
          <a :class="{'click-menu': $route.path === '/client/directtalk', 'startup': user.billing === 0}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0">
            <span class="mdi mdi-comment-processing-outline mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ロボ会話履歴</span>
          </a>
          <router-link to="/client/directtalk" :class="{'click-menu': $route.path === '/client/directtalk'}" class="hover-menu" v-else>
            <span class="mdi mdi-comment-processing-outline mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ロボ会話履歴</span>
          </router-link>
        </li>
        <li @mouseover="mouseleaveReset">
          <router-link to="/client/setting/app_icon" :class="{'click-menu': $route.path === '/client/setting/app_icon'}" class="hover-menu">
            <span class="mdi mdi-home mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ホームページ設定</span>
          </router-link>
        </li>
      </template>
      <!--  採用関連メニュー  -->
      <template v-if="shouldShowMenusAsAccordion">
        <!-- Accordion header for 採用関連メニュー -->
        <li class="list-direct accordion-header secondary" @click="toggleRecruitMenu" @mouseover="mouseleaveReset">
          <div class="hover-menu" style="cursor: pointer; display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; align-items: center;">
              <span v-if="!isMenuMiniSize" style="color: white; font-weight: 600; font-size: 13px;">採用関連メニュー</span>
            </div>
            <span v-if="!isMenuMiniSize" class="mdi mdi-light" :class="isRecruitMenuExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" style="color: white;"></span>
          </div>
        </li>
      </template>
      
      <!-- Original structure for super users -->
      <template v-else>
        <li class="list-direct secondary" @mouseover="mouseleaveReset">
          <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">採用関連メニュー</span></p>
          <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        </li>
      </template>
      <li>
        <div v-if="!isButtonDisabled">
        <a :class="{'click-menu': $route.path.indexOf('/client/manage') !== -1, 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
          <span class="mdi mdi-account-card-details mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">応募者管理</span>
        </a>
        <router-link to="/client/manage" :class="{'click-menu': $route.path.indexOf('/client/manage') !== -1, 'startup': user.billing === 0}" class="hover-menu" v-else>
          <span class="mdi mdi-account-card-details mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">応募者管理</span>
        </router-link>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-account-card-details mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">応募者管理</span>
        </div>
      </li>
      <!-- Accordion content for 採用関連メニュー -->
      <template v-if="shouldShowMenusAsAccordion">
        <template v-if="shouldShowRecruitMenuItems">
          <li @mouseover="mouseleaveReset">
            <div v-if="!isButtonDisabled">
            <a :class="{'click-menu': $route.path === '/client/employment/list', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
              <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
            </a>
            <router-link to="/client/employment/list?pages=1&recruit=true" :class="{'click-menu': $route.path === '/client/employment/list', 'startup': user.billing === 0}" class="hover-menu" v-else>
              <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
            </router-link>
            </div>
            <div class="hover-menu startup no-viewing-permission-applicant" v-else>
              <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
            </div>
          </li>
          <li class="list-direct" @mouseover="mouseleaveReset">
            <div v-if="!isButtonDisabled">
            <a :class="{'click-menu': $route.path === '/client/directtalk/scout', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
              <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
            </a>
            <router-link to="/client/directtalk/scout" :class="{'click-menu': $route.path === '/client/directtalk/scout', 'startup': user.billing === 0}" class="hover-menu" v-else>
              <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
            </router-link>
            </div>
            <div class="hover-menu startup no-viewing-permission-applicant" v-else>
              <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
            </div>
          </li>
          <li>
            <div v-if="!isButtonDisabled">
            <li class="list-setting" id="list-video-interview" @mouseover="mouseoverVideoInteview"  @mouseleave="mouseleaveVideoInteview">
              <a :class="{'click-menu': $route.path === '/client/recordview', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
                <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
                <span v-if="!isMenuMiniSize">録画面接</span>
              </a>
              <router-link to="/client/recordview" :class="{'click-menu': $route.path === '/client/recordview', 'startup': user.billing === 0}" class="hover-menu" v-else>
                <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
                <span v-if="!isMenuMiniSize">録画面接</span>
              </router-link>
            </li>
            </div>
            <div class="hover-menu startup no-viewing-permission-applicant" v-else>
              <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">録画面接</span>
            </div>
          </li>
          <li @mouseover="mouseleaveReset">
            <router-link to="/client/setting/common" :class="{'click-menu': $route.path === '/client/setting/common'}" class="hover-menu">
              <span class="mdi mdi-contact-mail mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">採用関連設定</span>
            </router-link>
          </li>
        </template>
      </template>
      
      <!-- Original structure for super users -->
      <template v-else>
        <li @mouseover="mouseleaveReset">
          <div v-if="!isButtonDisabled">
          <a :class="{'click-menu': $route.path === '/client/employment/list', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
            <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
          </a>
          <router-link to="/client/employment/list?pages=1&recruit=true" :class="{'click-menu': $route.path === '/client/employment/list', 'startup': user.billing === 0}" class="hover-menu" v-else>
            <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
          </router-link>
          </div>
          <div class="hover-menu startup no-viewing-permission-applicant" v-else>
            <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
          </div>
        </li>
        <li class="list-direct" @mouseover="mouseleaveReset">
          <div v-if="!isButtonDisabled">
          <a :class="{'click-menu': $route.path === '/client/directtalk/scout', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
            <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
          </a>
          <router-link to="/client/directtalk/scout" :class="{'click-menu': $route.path === '/client/directtalk/scout', 'startup': user.billing === 0}" class="hover-menu" v-else>
            <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
          </router-link>
          </div>
          <div class="hover-menu startup no-viewing-permission-applicant" v-else>
            <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
          </div>
        </li>
        <li>
          <div v-if="!isButtonDisabled">
          <li class="list-setting" id="list-video-interview" @mouseover="mouseoverVideoInteview"  @mouseleave="mouseleaveVideoInteview">
            <a :class="{'click-menu': $route.path === '/client/recordview', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
              <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">録画面接</span>
            </a>
            <router-link to="/client/recordview" :class="{'click-menu': $route.path === '/client/recordview', 'startup': user.billing === 0}" class="hover-menu" v-else>
              <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">録画面接</span>
            </router-link>
          </li>
          </div>
          <div class="hover-menu startup no-viewing-permission-applicant" v-else>
            <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">録画面接</span>
          </div>
        </li>
        <li @mouseover="mouseleaveReset">
          <router-link to="/client/setting/common" :class="{'click-menu': $route.path === '/client/setting/common'}" class="hover-menu">
            <span class="mdi mdi-contact-mail mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">採用関連設定</span>
          </router-link>
        </li>
      </template>
      <!--  共通メニュー  -->
      <template v-if="shouldShowMenusAsAccordion">
        <!-- Accordion header for 共通メニュー -->
        <li class="list-direct accordion-header secondary" @click="toggleCommonMenu" @mouseover="mouseleaveReset">
          <div class="hover-menu" style="cursor: pointer; display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; align-items: center;">
              <span v-if="!isMenuMiniSize" style="color: white; font-weight: 600; font-size: 13px;">共通メニュー</span>
            </div>
            <span v-if="!isMenuMiniSize" class="mdi mdi-light" :class="isCommonMenuExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" style="color: white;"></span>
          </div>
        </li>
      </template>
      
      <!-- Original structure for super users -->
      <template v-else>
        <li class="list-direct secondary" @mouseover="mouseleaveReset">
          <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">共通メニュー</span></p>
          <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        </li>
      </template>
      <li @mouseover="mouseleaveReset">
        <router-link to="/client/calendar" :class="{'click-menu': $route.path === '/client/calendar'}" class="hover-menu">
          <span class="mdi mdi-calendar-today mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">予定調整・カレンダー</span>
        </router-link>
      </li>
      <!-- Accordion content for 共通メニュー -->
      <template v-if="shouldShowMenusAsAccordion">
        <template v-if="shouldShowCommonMenuItems">
          <li>
            <div v-if="!isButtonDisabled">
            <li class="list-setting" id="list-video-interview" @mouseover="mouseoverVideoInteview"  @mouseleave="mouseleaveVideoInteview">
              <a :class="{'click-menu': $route.path === '/client/videoview', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
                <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
                <span v-if="!isMenuMiniSize">ウェブ会議</span>
              </a>
              <router-link to="/client/videoview" :class="{'click-menu': $route.path === '/client/videoview', 'startup': user.billing === 0}" class="hover-menu" v-else>
                <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
                <span v-if="!isMenuMiniSize">ウェブ会議</span>
              </router-link>
            </li>
            </div>
            <div class="hover-menu startup no-viewing-permission-applicant" v-else>
              <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ウェブ会議</span>
            </div>
          </li>
          <li @mouseover="mouseleaveReset">
            <div v-if="!isButtonDisabled">
            <a :class="{'click-menu': $route.path === '/client/mediapool', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
              <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
            </a>
            <router-link to="/client/mediapool" :class="{'click-menu': $route.path === '/client/mediapool', 'startup': user.billing === 0}" class="hover-menu" v-else>
              <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
            </router-link>
            </div>
            <div class="hover-menu startup no-viewing-permission-applicant" v-else>
              <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
            </div>
          </li>
        </template>
      </template>
      
      <!-- Original structure for super users -->
      <template v-else>
        <li>
          <div v-if="!isButtonDisabled">
          <li class="list-setting" id="list-video-interview" @mouseover="mouseoverVideoInteview"  @mouseleave="mouseleaveVideoInteview">
            <a :class="{'click-menu': $route.path === '/client/videoview', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
              <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ウェブ会議</span>
            </a>
            <router-link to="/client/videoview" :class="{'click-menu': $route.path === '/client/videoview', 'startup': user.billing === 0}" class="hover-menu" v-else>
              <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">ウェブ会議</span>
            </router-link>
          </li>
          </div>
          <div class="hover-menu startup no-viewing-permission-applicant" v-else>
            <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ウェブ会議</span>
          </div>
        </li>
        <li @mouseover="mouseleaveReset">
          <div v-if="!isButtonDisabled">
          <a :class="{'click-menu': $route.path === '/client/mediapool', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
            <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
          </a>
          <router-link to="/client/mediapool" :class="{'click-menu': $route.path === '/client/mediapool', 'startup': user.billing === 0}" class="hover-menu" v-else>
            <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
          </router-link>
          </div>
          <div class="hover-menu startup no-viewing-permission-applicant" v-else>
            <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
          </div>
        </li>
      </template>
      <li class="list-setting" id="list-setting" @mouseover="mouseoverSetting"  @mouseleave="mouseleaveSetting">
        <router-link to="/client/setting/personal" :class="{'click-menu': $route.path.indexOf('/client/setting/') !== -1 && $route.path !== '/client/setting/common' && $route.path !== '/client/setting/app_icon'}" class="hover-menu">
          <span class="mdi mdi-settings mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">設定</span>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListSettingFlg">
          <li v-if="user.billing === 3">
            <router-link to="/client/setting/billing" :class="{'click-submenu': $route.path === '/client/setting/billing'}">
              請求
            </router-link>
          </li>
          <li v-if="user.billing === 0">
            <router-link to="/client/setting/billing?view=plan" :class="{'click-submenu': $route.path === '/client/setting/billing'}">
              プランを選択
            </router-link>
          </li>
          <li>
            <router-link to="/client/setting/personal" :class="{'click-submenu': $route.path === '/client/setting/personal'}">
              個人設定
            </router-link>
          </li>
          <li>
            <router-link to="/client/setting/other_api" :class="{'click-submenu': $route.path === '/client/setting/other_api'}">
              外部連携
            </router-link>
          </li>
          <!-- ユーザー一覧は管理者権限のユーザーのみ表示 -->
          <li v-if="user.permission === 0">
            <router-link to="/client/setting/user_list" :class="{'click-submenu': $route.path === '/client/setting/user_list'}">
              ユーザー一覧
            </router-link>
          </li>
          <li>
            <router-link to="/client/setting/company" :class="{'click-submenu': $route.path === '/client/setting/company'}">
              会社情報
            </router-link>
          </li>
        </ul>
      </li>
      <li class="list-operation" id="list-operation" @mouseover="mouseoverOperation"  @mouseleave="mouseleaveOperation" v-if="user.isAgent">
        <router-link to="/client/operation/controllog" :class="{'click-menu': $route.path.indexOf('/client/operation/') !== -1}" class="hover-menu">
          <span class="mdi mdi-account-supervisor mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">運用</span>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListOperationFlg">
          <li>
            <router-link to="/client/operation/controllog" :class="{'click-submenu': $route.path === '/client/operation/controllog'}">
              操作履歴
            </router-link>
          </li>
          <!-- <li>
            <router-link to="/client/operation/recruitment_media" :class="{'click-submenu': $route.path === '/client/operation/recruitment_media'}">
              媒体情報
            </router-link>
          </li> -->
        </ul>
      </li>
      <!--  β版メニュー  -->
      <template v-if="shouldShowMenusAsAccordion">
        <!-- Accordion header for β版メニュー -->
        <li class="list-direct accordion-header secondary" @click="toggleBetaMenu" @mouseover="mouseleaveReset">
          <div class="hover-menu" style="cursor: pointer; display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; align-items: center;">
              <span v-if="!isMenuMiniSize" style="color: white; font-weight: 600; font-size: 13px;">β版メニュー</span>
            </div>
            <span v-if="!isMenuMiniSize" class="mdi mdi-light" :class="isBetaMenuExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" style="color: white;"></span>
          </div>
        </li>
        <!-- Accordion content for β版メニュー -->
        <template v-if="shouldShowBetaMenuItems">
          <li @mouseover="mouseleaveReset">
            <router-link to="/client/calendar/task" :class="{'click-menu': $route.path === '/client/calendar/task'}" class="hover-menu">
              <span class="mdi mdi-calendar-clock mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">タスク予定リスト</span>
            </router-link>
          </li>
          <li @mouseover="mouseleaveReset">
            <a :class="{'click-menu': $route.path === '/client/virtualoffice', 'startup': user.billing === 0}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0">
              <span class="mdi mdi-office-building mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">エンゲージメント</span>
            </a>
            <router-link to="/client/virtualoffice" :class="{'click-menu': $route.path === '/client/virtualoffice'}" class="hover-menu" v-else>
              <span class="mdi mdi-office-building mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">エンゲージメント</span>
            </router-link>
          </li>
          <li @mouseover="mouseleaveReset">
            <a :class="{'click-menu': $route.path === '/client/virtualoffice', 'startup': user.billing === 0}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0">
              <span class="mdi mdi-domain mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">オフィス</span>
            </a>
            <router-link to="/client/virtualoffice" :class="{'click-menu': $route.path === '/client/virtualoffice'}" class="hover-menu" v-else>
              <span class="mdi mdi-domain mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">オフィス</span>
            </router-link>
          </li>
          <li @mouseover="mouseleaveReset">
            <div v-if="!isButtonDisabled">
            <a :class="{'click-menu': $route.path === '/client/story', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
              <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">求人ノベル</span>
            </a>
            <router-link to="/client/story" :class="{'click-menu': $route.path === '/client/story'}" class="hover-menu" v-else>
              <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">求人ノベル</span>
            </router-link>
            </div>
            <div class="hover-menu startup no-viewing-permission-applicant" v-else>
              <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">求人ノベル</span>
            </div>
          </li>
          <!-- β版メニューの解析機能は削除（新しいレポーティング機能に移行） -->
          <!-- <li class="list-report" id="list-report" @mouseover="mouseoverReport"  @mouseleave="mouseleaveReport">
            <router-link to="/client/report" :class="{'click-menu': $route.path === '/client/report'}" class="hover-menu">
              <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
              <span v-if="!isMenuMiniSize">解析</span>
            </router-link>
            <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="reportFlg && user.billing !== 0">
              <li>
                <router-link to="/client/report" :class="{'click-submenu': $route.path === '/client/report'}">
                  応募者解析レポート
                </router-link>
              </li>
            </ul>
          </li> -->
        </template>
      </template>
      
      <!-- Original structure for super users -->
      <template v-else>
        <li class="list-direct secondary" @mouseover="mouseleaveReset">
          <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">β版メニュー</span></p>
          <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        </li>
        <li @mouseover="mouseleaveReset">
          <router-link to="/client/calendar/task" :class="{'click-menu': $route.path === '/client/calendar/task'}" class="hover-menu">
            <span class="mdi mdi-calendar-clock mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">タスク予定リスト</span>
          </router-link>
        </li>
        <li @mouseover="mouseleaveReset">
          <a :class="{'click-menu': $route.path === '/client/virtualoffice', 'startup': user.billing === 0}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0">
            <span class="mdi mdi-home mdi-24px mdi-office-building mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">エンゲージメント<br>オフィス</span>
            <span v-else>&nbsp;<br>&nbsp;</span>
          </a>
          <router-link to="/client/virtualoffice" :class="{'click-menu': $route.path === '/client/virtualoffice', 'startup': user.billing === 0}" class="hover-menu" v-else>
            <span class="mdi mdi-home mdi-24px mdi-office-building mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">エンゲージメント<br>オフィス</span>
            <span v-else>&nbsp;<br>&nbsp;</span>
          </router-link>
        </li>
        <li @mouseover="mouseleaveReset">
          <div v-if="!isButtonDisabled">
          <a :class="{'click-menu': $route.path === '/client/story', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
            <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">求人ノベル</span>
          </a>
          <router-link to="/client/story" :class="{'click-menu': $route.path === '/client/story', 'startup': user.billing === 0}" class="hover-menu" v-else>
            <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">求人ノベル</span>
          </router-link>
          </div>
          <div class="hover-menu startup no-viewing-permission-applicant" v-else>
            <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">求人ノベル</span>
          </div>
        </li>
        <!-- β版メニューの解析機能は削除（新しいレポーティング機能に移行） -->
        <!-- <li class="list-report" id="list-report" @mouseover="mouseoverReport"  @mouseleave="mouseleaveReport">
          <router-link to="/client/report" :class="{'click-menu': $route.path === '/client/report'}" class="hover-menu">
            <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">解析</span>
          </router-link>
          <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="reportFlg && user.billing !== 0">
            <li>
              <router-link to="/client/report" :class="{'click-submenu': $route.path === '/client/report'}">
                応募者解析レポート
              </router-link>
            </li>
          </ul>
        </li> -->
      </template>
      <!-- 少し隙間を空ける -->
      <li class="list-direct">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
      <li @mouseover="mouseleaveReset">
        <a class="hover-menu" @click="logout()">
          <span class="mdi mdi-logout mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ログアウト</span>
        </a>
      </li>
      <!-- 最後のメニューが見えにくくなることがあるので隙間を作る -->
      <li class="list-direct">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import session from '@/api/session'
import RoboCreate        from '@/components2/Robo/modal/RoboCreate'
import RoboCreateRequest from '@/components2/Robo/modal/RoboCreateRequest'
import controlLogMixin   from '@/mixins/controlLogMixin'
import ModalRequestHelp from '@/components/ui/ModalRequestHelp'
import ReleaseMarkdown from '../Release/ReleaseMarkdown'
import ViewMarkdown from '../Release/ViewMarkdown'
import Push from 'push.js'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import ModalAlertDialog from '@/components/organisms/common/ModalAlertDialog'
import {
  isRoboEditPermission,
  isRoboDisplayPermission
} from '@/functions/checkPermission'
import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
  /** アラートダイアログ用データ作成 */
  createAlertData
} from '@/functions/common/alertFunc'
export default {
  name: 'ClientMainMenu',
  componentName: 'ClientMainMenu',
  components: {
    ModalRequestHelp,
    ReleaseMarkdown,
    ViewMarkdown,
    Tooltip,
    ModalAlertDialog,
    RoboCreate,
    RoboCreateRequest,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    height: {
      type: String,
      default: '0px'
    }
  },
  data () {
    return {
      ListRoboCreateFlg: false,
      ListRoboFlg: false,
      ListSettingFlg: false,
      ListOperationFlg: false,
      ListDirectFlg: false,
      ListVideoInteviewFlg: false,
      isDebug: false,
      isShowBillingNoFeature: false,
      isShowBilling: false,
      isShowRoboCreate: false,
      isShowRoboCreateRequest: false,
      ListUserInfoFlg: false,
      menuActive: false,
      isChangedCompanyID: false,
      selectCompanyID: '',
      isReleaseMarkdown: false,
      isViewMarkdown: false,
      storageData: {},
      localData: [],
      releaseData: [],
      isMessage: false,
      messageData: {},
      activeVisitor: [],
      isVisitorInit: false,
      isDeniedCheck: false,
      start: Date.now(),
      executed: false,
      currentCompany: '',
      companySearchText: '',
      isAlertDialogOpen: false,
      alertData: {},
      reportFlg: false,
      isRoboMenuExpanded: false,
      isBetaMenuExpanded: false,
      isRecruitMenuExpanded: false,
      isCommonMenuExpanded: false,
      // ロボグリッド表示用（追加）
      roboGridVisible: false,      // グリッド表示フラグ
      hideTimer: null,              // 非表示タイマー
      currentEditingScenario: null, // 現在編集中のシナリオ
      popupPosition: {},            // ポップアップの位置情報
    }
  },
  computed: {
    ...mapState('virtualOffice', ['isVOConnectList']),
    ...mapState('sitemap', ['isFirstLoad', 'firstLoadCount']),
    ...mapState('directtalk', ['chatData', 'isConnectList','roomcount', 'roomlist', 'sortFlg', 'filterFlg']),
    ...mapState('chatbot', ['chatbots', 'isCBLoading']),
    ...mapState('auth', ['user', 'isModalRequestHelp', 'companyList']),
    ...mapState("tools",["releaseContents", "draftTexts", "releaseTexts"]),
    ...mapState("setting",["isMenuMiniSize"]),
    filteredCompanyList() {
      // キャンセル状態でない会社のみをフィルタリングし、会社名の五十音順で並び替える
      return this.companyList 
        ? this.companyList
            .filter(company => !company.is_cancel)
            .sort((a, b) => a.name.localeCompare(b.name, 'ja'))
        : [];
    },
    filteredCompanyListForAutocomplete() {
      // autocomplete用に検索テキストでフィルタリング
      const searchText = this.companySearchText.toLowerCase()
      return this.filteredCompanyList.filter(company => 
        company.name.toLowerCase().includes(searchText)
      ).slice(0, 50) // パフォーマンスのため最大50件まで表示
    },
    profileImage: function () {
      return this.user.profileIcon
    },
    currentCompanyName() {
      // 現在選択されている会社の名前を取得
      if (this.companyList && this.user.companyID) {
        const company = this.companyList.find(c => c.id === this.user.companyID)
        return company ? company.name : this.user.companyName
      }
      return this.user.companyName
    },
    plan () {
      if (this.user.billing === 0) return '無料プラン'
      else if (this.user.billing === 1) return 'ライトプラン'
      else if (this.user.billing === 2) return 'スタンダードプラン'
      else if (this.user.billing === 3) return '従量課金プラン'
      else return '有料プラン'
    },
    dropdownListHeight () {
      let el = undefined
      if (this.ListRoboCreateFlg) el = document.getElementById('list-robo-employment')
      else if (this.ListRoboFlg) el = document.getElementById('list-robo')
      else if (this.ListSettingFlg) el = document.getElementById('list-setting')
      else if (this.ListOperationFlg) el = document.getElementById('list-operation')
      else if (this.ListVideoInteviewFlg) el = document.getElementById('list-video-interview')
      else if (this.ListUserInfoFlg) el = document.getElementById('list-info')
      else if (this.reportFlg) el = document.getElementById('list-report')
      else return 'top: 0px;'
      return 'top: ' + el.getBoundingClientRect().top + 'px;';
    },
    isButtonDisabled () {
      return !this.user.isSeekerDisplayEnable
    },
    shouldShowRoboMenuItems () {
      return this.user.isAgent || this.isRoboMenuExpanded
    },
    shouldShowBetaMenuItems () {
      return this.user.isAgent || this.isBetaMenuExpanded
    },
    shouldShowMenusAsAccordion () {
      return !this.user.isAgent
    },
    shouldShowRecruitMenuItems () {
      return this.user.isAgent || this.isRecruitMenuExpanded
    },
    shouldShowCommonMenuItems () {
      return this.user.isAgent || this.isCommonMenuExpanded
    },
    // 稼働中のロボを取得
    lockedRobots() {
      // Step1: chatbotsの存在と型チェック
      if (!this.chatbots || !Array.isArray(this.chatbots)) {
        return [];
      }
      
      // Step2: ユーザー情報の存在チェック
      if (!this.user) {
        return [];
      }
      
      // Step3: 対象会社ハッシュの決定
      // APIはgroupフィールドにcompany_hashが格納されている
      // companyIDが実際のcompany_hash、companyHashはuser.uuid
      const targetCompanyId = this.user.isAgent && this.currentCompany 
        ? this.currentCompany 
        : this.user.companyID;
      
      // Step4: 会社IDの妥当性チェック
      if (!targetCompanyId) {
        return [];
      }
      
      // Step5: 稼働中のロボをフィルタリング
      try {
        const result = this.chatbots.filter(robo => {
          // 個別のロボデータチェック
          if (!robo || typeof robo !== 'object') {
            return false;
          }
          // APIはgroupフィールドを使用してcompany_hashでフィルタリング
          // 注意: targetCompanyIdは実際にはcompany_hashを格納している
          // アーカイブされていない、かつis_confirmがtrueのロボットを表示
          // permission 0のユーザー、または閲覧権限・編集権限のあるユーザーが閲覧可能
          return robo.group === targetCompanyId && 
                 robo.is_confirm === true && 
                 !robo.is_archive && 
                 (this.user.permission === 0 || 
                  isRoboDisplayPermission(robo, this.user) === true ||
                  isRoboEditPermission(robo, this.user) === true);
        });
        return result;
      } catch (error) {
        return [];
      }
    },
    // 表示するロボ（最大9台）
    displayedRobos() {
      return this.lockedRobots.slice(0, 9)
    },
    // 10台以上あるか
    hasMoreRobos() {
      return this.lockedRobots.length > 9
    },
    // 追加ロボ数
    moreRoboCount() {
      return Math.max(0, this.lockedRobots.length - 9)
    },
    // グリッドクラスの動的判定
    getGridClass() {
      const count = this.lockedRobots.length
      if (count <= 5) {
        return 'grid-single-row'
      } else if (count <= 9) {
        return 'grid-three-columns'
      } else {
        return 'grid-three-columns grid-with-more'
      }
    }
  },
  // TODO: ローカライズ始まるまでは一旦切り替えないで日本語固定で
  mounted () {
    window.addEventListener('focus', this.focusIn)
    this.currentCompany = this.user.companyID
    // 現在の会社名を検索テキストに設定
    if (this.companyList) {
      const currentCompanyObj = this.companyList.find(c => c.id === this.user.companyID)
      if (currentCompanyObj) {
        this.companySearchText = currentCompanyObj.name
      }
    }
    this.$store.dispatch("tools/getText")
    this.localData = []
    this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
    if (this.storageData == null) {
      this.storageData = {}
    }
    for (var i = 0; i < Object.keys(this.storageData).length; i++) {
      this.localData.push(this.storageData[i])
    }
    setTimeout(() => {this.handleClick_changeLanguage('ja')}, 2000)
  },
  watch: {
    user: {
      handler(newVal, oldVal) {
        // ユーザーの会社IDが変更された場合
        if (oldVal && newVal.companyID !== oldVal.companyID) {
          // 現在の会社名を検索テキストに更新
          if (this.companyList) {
            const currentCompanyObj = this.companyList.find(c => c.id === newVal.companyID)
            if (currentCompanyObj) {
              this.companySearchText = currentCompanyObj.name
            }
          }
          this.currentCompany = newVal.companyID
        }
      },
      deep: true
    },
    releaseTexts () {
      this.releaseData = []
      for (var i = 0; i < this.releaseTexts.length; i++)
        this.releaseData.push(this.releaseTexts[i].contents_id + "/" + this.getSort(this.releaseTexts[i].updated_at))
      var newMessage = []
      newMessage = this.releaseData.filter(i => this.localData.indexOf(i) == -1)
      if (newMessage.length == 0) {
        this.messageFlag = false
      } else {
        this.messageFlag = true
      }
      this.isMessage = this.releaseTexts.map(v => v.is_read).includes(true)
    },
    roomcount () {
      let interval = Date.now() - this.start
      if (!this.sortFlg && !this.filterFlg) {
        if (interval > 10000) {
          this.executed = false
          this.getScoutSeeker()
        } else {
          if (!this.executed) {
            setTimeout(this.getScoutSeeker, 10000)
          }
          this.executed = true
        }
      }
      // 現在の訪問者数
      if (this.user.isNoticeNewVisitor) {
        // 起動時の訪問者情報取得
        if (!this.isVisitorInit) {
          // 起動時初回は現状の情報を通知処理前に取得しておく
          this.activeVisitor = this.roomlist.active
          this.isVisitorInit = true
        }

        // 通知設定チェック
        if (Push.Permission.get() === Push.Permission.DENIED && !this.isDeniedCheck) {
          // 通知の拒否設定がされていた場合、初回だけメッセージを表示する
          alert('訪問者通知の設定\nHRモンスターからの通知が拒否されています。\nブラウザの設定から通知を許可してください。')
          this.isDeniedCheck = true
          return
        } else if (Push.Permission.get() === Push.Permission.DENIED && this.isDeniedCheck) {
          // 通知拒否チェック済みの場合は何もしないで抜ける
          return
        } else if (Push.Permission.get() !== Push.Permission.GRANTED) {
          // この時点で通知未承認の場合、承認要求を行う
          Push.Permission.request()
        }

        // プッシュ通知
        if (Push.Permission.get() === Push.Permission.GRANTED) {
          // 通知承認済みなら新しい訪問者が来たかチェックする
          let isNewVisitor = false
          for (const room of this.roomlist.active) {
            let isVisiting = false
            for (const visitor of this.activeVisitor) {
              if (room.name === visitor.name) {
                // 現在訪問中の人
                isVisiting = true
                break
              }
            }
            if (!isVisiting) {
              // 新しく来た訪問者
              isNewVisitor = true
              // 1人でも新規の訪問者がいたら通知するので抜ける
              break
            }
          }
          // 現状の訪問者情報を退避
          this.activeVisitor = this.roomlist.active

          // プッシュ通知で表示
          if (isNewVisitor) {
            Push.create('HRモンスターからのお知らせ', {
              body: '新しい訪問者がいらっしゃいました！',
              icon: require('../../assets/lp/logo.png'),
              timeout: 5000,
              onClick: function () {
                window.focus()
                this.close()
              }
            })
          }
        }
      }
    },
    isModalRequestHelp () {
      this.allClose()
    },
    isConnectList () {
      if (!this.isConnectList) {
        setTimeout(() => {
          const uri = process.env.WS_ENDPOINT + 'list/' + this.user.companyID + '/' + this.user.email
          this.$store.dispatch('directtalk/connectList', uri)
        }, 5000)
      }
    },
    isVOConnectList () {
      if (!this.isVOConnectList) {
        setTimeout(() => {
          const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
          this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
        }, 5000)
      }
    },
  },
  updated () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  beforeDestroy () {
    this.$store.dispatch('virtualOffice/sendVirtualOfficeSV', '[DISCONNECT]')
  },
  destroyed () {
    setTimeout(() => {
      this.$store.dispatch('virtualOffice/disconnectVirtualOfficeSV')
    }, 500)
  },
  methods: {
    allClose () {
      this.ListDirectFlg = false
      this.ListRoboCreateFlg = false
      this.ListRoboFlg = false
      this.ListSettingFlg = false
      this.ListOperationFlg = false
      this.ListVideoInteviewFlg = false
      this.ListUserInfoFlg = false
      this.reportFlg = false
    },
    showRoboCreate (flag) {
      this.allClose()
      this.isShowRoboCreate = flag
    },
    showRoboCreateRequest (flag) {
      this.allClose()
      this.isShowRoboCreateRequest = flag
    },
    handleClick_changeLanguage (lang) {
      this.$i18n.locale = lang
    },
    logout () {
      this.$store.dispatch('auth/logout')
        .then(() => {
          // ログアウト後はAPIが叩けなくなるため、ログアウト前に離脱ログを送信する
          const p1 = this.sendControlLogRelatedUsage('HRモンスター離脱', 'HRモンスターの管理ページを閉じた')
          const p2 = this.sendControlLog('ログアウト', '画面左側メニューのログアウトボタンをクリックした。')
          return Promise.all([p1, p2])
        })
        .then(() => {
          this.logoutBar()
        })
    },
    logoutBar () {
      this.$buefy.snackbar.open({
        message: 'ログアウトしました。',
        type: 'is-primary',
        position: 'is-top'
      })
      document.location.href = '/login'
    },
    setRHModal () {
      this.$store.dispatch('auth/setRHModal')
    },
    getCompanyList () {
      this.$store.dispatch('auth/getCompanyList')
    },
    updateUserCompany (id) {
      this.$store.dispatch('auth/updateUserCompany', {companyID: id}).then(() => {
        // 会社が更新されたら、検索テキストをクリア
        this.companySearchText = ''
        this.currentCompany = ''
        // 新しい会社名を検索テキストに設定
        if (this.companyList) {
          const newCompany = this.companyList.find(c => c.id === id)
          if (newCompany) {
            this.companySearchText = newCompany.name
          }
        }
      })
    },
    releaseMarkdownModal () {
      this.allClose()
      this.isReleaseMarkdown = true
    },
    viewMarkdownModal () {
      this.allClose()
      this.isViewMarkdown = true
      this.localData = []
      this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
      if (this.storageData == null) {
        this.storageData = {}
      }
      for (var i = 0; i < Object.keys(this.storageData).length; i++) {
        this.localData.push(this.storageData[i])
      }
    },
    getTimes (time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time
        .replace(/Jan/g, '01')
        .replace(/Feb/g, '02')
        .replace(/Mar/g, '03')
        .replace(/Apr/g, '04')
        .replace(/May/g, '05')
        .replace(/Jun/g, '06')
        .replace(/Jul/g, '07')
        .replace(/Aug/g, '08')
        .replace(/Sep/g, '09')
        .replace(/Oct/g, '10')
        .replace(/Nov/g, '11')
        .replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_time = new_time.substring(15,20)
      var dis_time = get_year + '-' + get_month + '-' + get_day + ' ' + get_time
      return dis_time
    },
    getSort (time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time
        .replace(/Jan/g, '01')
        .replace(/Feb/g, '02')
        .replace(/Mar/g, '03')
        .replace(/Apr/g, '04')
        .replace(/May/g, '05')
        .replace(/Jun/g, '06')
        .replace(/Jul/g, '07')
        .replace(/Aug/g, '08')
        .replace(/Sep/g, '09')
        .replace(/Oct/g, '10')
        .replace(/Nov/g, '11')
        .replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_hour = new_time.substring(15,17)
      var get_minute = new_time.substring(18,20)
      var dis_time = get_year + get_month + get_day + get_hour + get_minute
      return Number(dis_time)
    },
    sendMessage () {
      var readID = localStorage.getItem('IS_RELEASE_READ')
      var dataDate = []
      var array=[]
      var result=[]
      var releaseID = 1000000000000
      var contentsID = ""
      for (var i in this.localData) {
        dataDate.push(this.localData[i].slice(-12))
      }
      result = dataDate.filter(function (item) {
        return item.indexOf("undefined")== -1 && item.indexOf("000000000000")== -1
      })
      var sortDataDate = result.sort().pop()

      if (readID != null) {
        for (let i in this.releaseTexts) {
          if (this.getSort(this.releaseTexts[i].updated_at) >= sortDataDate) {
            array.push(this.getSort(this.releaseTexts[i].updated_at))
          }
        }
        array.sort(function (a, b) {
          if(a < b) return -1;
          if(a > b) return 1;
          return 0;
        })
        return array[0]
      } else {
        for (let i in this.releaseTexts) {
          if (this.getSort(this.releaseTexts[i].updated_at) < releaseID) {
            releaseID = this.getSort(this.releaseTexts[i].updated_at)
            contentsID = this.releaseTexts[i].contents_id
          }
        }
        this.messageData[Object.keys(this.storageData).length] = contentsID + "/" + releaseID
        return releaseID
      }
    },
    sendID () {
      var sendID = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendID = this.releaseTexts[i].contents_id
        }
      }
      return sendID
    },
    sendValue () {
      var sendValue = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendValue = this.releaseTexts[i].contents
        }
      }
      return sendValue
    },
    sendDate () {
      var sendDate = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendDate = this.getTimes(this.releaseTexts[i].updated_at)
        }
      }
      return sendDate
    },
    sendTitle () {
      var sendTitle = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendTitle = this.releaseTexts[i].title
        }
      }
      return sendTitle
    },
    getScoutSeeker () {
      return
      // this.$store.dispatch('directtalk/getSeeker', 'scout')
    },
    contentsMethod () {
      this.localData=[]
      this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
      if (this.storageData == null) {
        this.storageData = {}
      }
      for (var i = 0; i < Object.keys(this.storageData).length; i++) {
        this.localData.push(this.storageData[i])
      }
    },
    getAliveDay () {
      return 10 + '日'
    },
    alertResult (alertResultData) {
      if (alertResultData) {
        if (alertResultData.alertKeyFunction === 'client-nav') {
          if (alertResultData.alertKeyWord === 'reload-alert') {
            this.isAlertDialogOpen = false
            // リロードして応募者管理画面へ
            location.href = '/client/manage'
          }
        }
      }
    },
    focusIn () {
      // 現在の会社IDを取得
      const afterCompany = localStorage.getItem('_user_c')
      if (this.user.companyID !== afterCompany) {
        // 別のタブかウィンドウで会社が変更されていたらアラートを出してリロードする
        this.alertData = createAlertData(
          '会社変更リロード',
          '他のタブかウィンドウで会社が変更されました。\nリロードします。',
          ALERT_DEF.MESSAGE_INFO,
          ALERT_DEF.DIALOG_ALERT,
          'client-nav',
          'reload-alert'
        )
        this.isAlertDialogOpen = true
      }
    },
    mouseleaveReset () {
      this.ListDirectFlg = false
      this.ListRoboCreateFlg = false
      this.ListRoboFlg = false
      this.ListSettingFlg = false
      this.ListOperationFlg = false
      this.ListVideoInteviewFlg = false
      this.ListUserInfoFlg = false
      this.reportFlg = false
      this.roboGridVisible = false  // 追加
      this.clearHideTimer()         // 追加
    },
    mouseoverDirect (e) {
      this.ListDirectFlg = true
    },
    mouseleaveDirect (e) {
      if (e.clientX > 210) this.ListDirectFlg = false
    },
    mouseoverListRoboCreate (e) {
      this.mouseleaveReset()
      this.ListRoboCreateFlg = true
    },
    mouseleaveListRoboCreate (e) {
      if (e.clientX > 210) this.ListRoboCreateFlg = false
    },
    mouseoverListRobo (e) {
      this.mouseleaveReset()
      this.ListRoboFlg = true
    },
    mouseleaveListRobo (e) {
      if (e.clientX > 210) this.ListRoboFlg = false
    },
    mouseoverSetting (e) {
      this.mouseleaveReset()
      this.ListSettingFlg = true
    },
    mouseleaveSetting (e) {
      if (e.clientX > 210) this.ListSettingFlg = false
    },
    mouseoverOperation (e) {
      this.mouseleaveReset()
      this.ListOperationFlg = true
    },
    mouseleaveOperation (e) {
      if (e.clientX > 210) this.ListOperationFlg = false
    },
    mouseoverVideoInteview (e) {
      this.ListVideoInteviewFlg = true
    },
    mouseleaveVideoInteview (e) {
      if (e.clientX > 210) this.ListVideoInteviewFlg = false
    },
    mouseoverReport (e) {
      this.mouseleaveReset()
      this.reportFlg = true
    },
    mouseleaveReport (e) {
      if (e.clientX > 210) this.reportFlg = false
    },
    moveToScenarioTop () {
      let chatbot = this.chatbots.find((bot)=>!bot.is_archive && isRoboEditPermission(bot, this.user) === true && bot.is_template === false)
      if (chatbot) {
        this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: chatbot.scenario_name })
        this.$store.dispatch('chatbot/selectChatbot', chatbot)
        this.$router.push('/client/chatbot?view=scenario&scenario=' + chatbot.scenario_name)
      } else {
        alert('編集権限のあるロボがいないため、ロボ編集画面に遷移できません。')
      }
    },
    moveToLockedRoboScenario () {
      // 稼働中のロボがある場合は最初のロボを編集
      if (this.lockedRobots && this.lockedRobots.length > 0) {
        const chatbot = this.lockedRobots[0];
        // 編集権限があるかチェック
        if (isRoboEditPermission(chatbot, this.user) === true) {
          this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: chatbot.scenario_name })
          this.$store.dispatch('chatbot/selectChatbot', chatbot)
          this.$router.push('/client/chatbot?view=scenario&scenario=' + chatbot.scenario_name)
        } else {
          alert('このロボの編集権限がありません。')
        }
      } else {
        // 稼働中のロボがない場合は通常の動作
        this.moveToScenarioTop()
      }
    },
    isMenuMinimumSize () {
      this.$store.dispatch('setting/changeMenuMiniSize')
    },
    mouseoverUserInfo (e) {
      this.ListUserInfoFlg = true
    },
    mouseleaveUserInfo (e) {
      if (e.clientX > 210) this.ListUserInfoFlg = false
    },
    toggleRoboMenu () {
      this.isRoboMenuExpanded = !this.isRoboMenuExpanded
      if (this.isRoboMenuExpanded) {
        this.isBetaMenuExpanded = false
        this.isRecruitMenuExpanded = false
        this.isCommonMenuExpanded = false
      }
    },
    toggleBetaMenu () {
      this.isBetaMenuExpanded = !this.isBetaMenuExpanded
      if (this.isBetaMenuExpanded) {
        this.isRoboMenuExpanded = false
        this.isRecruitMenuExpanded = false
        this.isCommonMenuExpanded = false
      }
    },
    toggleRecruitMenu () {
      this.isRecruitMenuExpanded = !this.isRecruitMenuExpanded
      if (this.isRecruitMenuExpanded) {
        this.isRoboMenuExpanded = false
        this.isBetaMenuExpanded = false
        this.isCommonMenuExpanded = false
      }
    },
    toggleCommonMenu () {
      this.isCommonMenuExpanded = !this.isCommonMenuExpanded
      if (this.isCommonMenuExpanded) {
        this.isRoboMenuExpanded = false
        this.isBetaMenuExpanded = false
        this.isRecruitMenuExpanded = false
      }
    },
    /**
     * ロボアイコンのURLを取得
     * @param {Object} robo - ロボオブジェクト
     * @returns {String} アイコンURL
     */
    getRoboIconUrl(robo) {
      // デフォルトアイコンを直接requireで読み込み
      const defaultIconUrl = require('@/assets/template/robot.png');
      
      try {
        // Step1: roboオブジェクトの存在チェック
        if (!robo || typeof robo !== 'object') {
          return defaultIconUrl;
        }
        
        // Step2: icon_dataの存在と型チェック
        if (!robo.icon_data || typeof robo.icon_data !== 'string') {
          return defaultIconUrl;
        }
        
        // Step3: URLまたはBase64形式の検証
        const iconData = robo.icon_data.trim();
        
        // Base64形式のチェック（data:image/で始まる）
        if (iconData.startsWith('data:image/')) {
          // Base64の基本的な形式チェック
          const base64Pattern = /^data:image\/(png|jpg|jpeg|gif|svg\+xml);base64,/;
          if (base64Pattern.test(iconData)) {
            return iconData;
          }
          return defaultIconUrl;
        }
        
        // URL形式のチェック
        if (iconData.startsWith('http://') || iconData.startsWith('https://')) {
          // 簡易的なURL検証
          try {
            new URL(iconData); // URL形式の妥当性チェック
            return iconData;
          } catch (urlError) {
            return defaultIconUrl;
          }
        }
        
        // 相対パスの場合（/で始まる）
        if (iconData.startsWith('/')) {
          return iconData;
        }
        
        // それ以外の形式は無効とする
        return defaultIconUrl;

      } catch (error) {
        return defaultIconUrl;
      }
    },

    /**
     * 稼働中のロボ名一覧を取得（ツールチップ表示用）
     * @param {Array} robos - ロボの配列
     * @returns {String} カンマ区切りのロボ名一覧
     */
    getLockedRoboNames(robos) {
      if (!robos || !Array.isArray(robos)) {
        return '';
      }
      return robos.map(robo => robo.name || 'ロボ').join(', ');
    },
    
    /**
     * 画像読み込みエラー時のハンドラー
     * @param {Event} event - エラーイベント
     */
    handleIconError(event) {
      // デフォルトアイコンに差し替え
      event.target.src = require('@/assets/template/robot.png');

      // 無限ループ防止（デフォルトアイコンも読み込めない場合）
      if (event.target.dataset.retryCount) {
        const retryCount = parseInt(event.target.dataset.retryCount);
        if (retryCount >= 1) {
          // 透明な1x1のGIFを設定（最終手段）
          event.target.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
          return;
        }
      }
      event.target.dataset.retryCount = '1';
    },
    // ロボアイコンへのマウスエンター
    handleRoboMouseEnter(event) {
      if (this.lockedRobots.length > 1) {
        // 他のドロップダウンを閉じる
        this.mouseleaveReset()
        this.calculatePopupPosition(event)
        this.roboGridVisible = true
        this.clearHideTimer()
      }
    },
    // ロボアイコンからのマウスリーブ
    handleRoboMouseLeave() {
      this.startHideTimer()
    },
    // ポップアップへのマウスエンター
    cancelHideTimer() {
      this.clearHideTimer()
    },
    // ポップアップからのマウスリーブ
    handlePopupMouseLeave() {
      this.startHideTimer()
    },
    // 非表示タイマー開始
    startHideTimer() {
      this.clearHideTimer()
      this.hideTimer = setTimeout(() => {
        this.roboGridVisible = false
      }, 100)
    },
    // タイマークリア
    clearHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
    },
    // ポップアップの位置を計算
    calculatePopupPosition(event) {
      const targetElement = event.currentTarget
      const rect = targetElement.getBoundingClientRect()
      
      // マウスオーバーした要素の右側にポップアップを配置
      const left = rect.right + 10 // 要素の右端から10px離す
      const top = rect.top - 20 // 要素の上端から少し上に配置
      
      // 画面外にはみ出さないよう調整
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const popupWidth = 280 // ポップアップの想定幅
      const popupHeight = 280 // ポップアップの想定高さ
      
      let finalLeft = left
      let finalTop = top
      
      // 右端がはみ出る場合は左側に配置
      if (left + popupWidth > windowWidth) {
        finalLeft = rect.left - popupWidth - 10
      }
      
      // 下端がはみ出る場合は上に調整
      if (top + popupHeight > windowHeight) {
        finalTop = windowHeight - popupHeight - 20
      }
      
      // 上端がはみ出る場合は下に調整
      if (finalTop < 20) {
        finalTop = 20
      }
      
      this.popupPosition = {
        position: 'fixed',
        left: finalLeft + 'px',
        top: finalTop + 'px',
        zIndex: 1001
      }
    },
    // 個別ロボの編集画面へ遷移
    moveToSpecificRobo(robo) {
      if (isRoboEditPermission(robo, this.user) === true) {
        this.$store.dispatch('chatbot/getScenario', {
          companyid: this.user.companyID,
          scenarioName: robo.scenario_name
        })
        this.$store.dispatch('chatbot/selectChatbot', robo)
        this.$router.push('/client/chatbot?view=scenario&scenario=' + robo.scenario_name)
        this.roboGridVisible = false
      } else {
        this.$buefy.notification.open({
          message: 'このロボの編集権限がありません。',
          type: 'is-warning',
          position: 'is-top'
        })
      }
    },
    // 在籍ロボ一覧へ遷移
    navigateToRoboList() {
      this.moveToScenarioTop()
      this.roboGridVisible = false
    },
    // 名前を指定文字数で切り詰め
    truncateName(name, maxLength) {
      if (!name) return ''
      if (name.length <= maxLength) {
        return name
      }
      return name.substring(0, maxLength - 1) + '...'
    }
  },
  beforeDestroy () {
    window.removeEventListener('focus', this.focusIn)
    this.clearHideTimer() // タイマーのクリーンアップ（追加）
  },
  created () {
    this.$store.dispatch('auth/getcreateManage')
    this.$store.dispatch('sitemap/getSitemapRootList')
    this.$store.dispatch('auth/getScout')
    this.$store.dispatch('auth/getUsers')
    this.$store.dispatch('mediapool/getAllImages')
    this.$store.dispatch('mediapool/getAllVideos')
    this.$store.dispatch('auth/getDepartment', null)
    this.$store.dispatch('auth/getPosition', null)
    this.$store.dispatch('chatbot/getChatBotTag', null)
    this.$store.dispatch('chatbot/getChatBots')
    this.$store.dispatch('chatbot/getRoboPartsSet', this.user.companyID)
    this.$store.dispatch('chatbot/getStory')
    this.$store.dispatch('virtualOffice/getVirtualOffice', null)
    var con = {
      'is_connect': true
    }
    this.$store.dispatch('auth/setUserConnect', con)
    this.$store.dispatch('auth/getStoreCateogry')
    this.$store.dispatch('chatbot/getChatBotStoreItem')
    this.$store.dispatch('auth/getGoogleDriveAuthStatus')
    this.$store.dispatch('auth/getUsersStatusAPI')
    const uri = process.env.WS_ENDPOINT + 'list/' + this.user.companyID + '/' + this.user.email
    this.$store.dispatch('directtalk/connectList', uri)
    this.$store.dispatch('auth/payperuseInfo')
    // 無料トライアル過ぎている場合
    let deltaDay = (new Date() - new Date(this.user.createdAt)) / 86400000
    if (deltaDay > 14 && this.user.billing === 0) {
      this.isShowBilling = true
    }
    this.getCompanyList()
  },
}
</script>

<style lang="scss" scoped>
/* Autocomplete dropdown カスタムスタイル */
::v-deep .autocomplete {
  .dropdown-content {
    max-width: none !important;
    min-width: 300px !important;
    width: auto !important;
  }
  
  .dropdown-item {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: initial !important;
    padding: 0.375rem 1rem !important;
  }
  
  .dropdown-menu {
    width: auto !important;
    max-width: 400px !important;
    min-width: 300px !important;
  }
  
  .media {
    align-items: flex-start !important;
  }
  
  .media-content {
    overflow: visible !important;
    text-overflow: initial !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
  }
}
.custom-menu {
  background: #AA0066;
  min-width: 210px;
  max-width: 210px;
  height: calc(100vh - 1px);
  margin: 0 !important;
  display: flex;
  text-align: left;
  z-index: 100000;
}
.custom-menu-min {
  background: #AA0066;
  min-width: 50px;
  max-width: 50px;
  height: calc(100vh - 1px);
  margin: 0 !important;
  display: flex;
  text-align: left;
  z-index: 100000;
}
.menu-list {
  width: 200px;
  font-size: smaller;
}
.click-menu {
  background-color:rgba(240, 200, 200, 0.8) !important;
}
.hover-menu {
  color: white;
  transition: 0.5s;
  display: flex;
  align-items: center;
}
.hover-menu:hover {
  color: white;
  background-color:rgba(240, 200, 200, 0.8) !important;
}
.startup {
  cursor: not-allowed;
  color: rgba(240, 200, 200, 0.8);
}
.startup:hover {
  cursor: not-allowed;
  color: rgba(240, 200, 200, 0.8);
}
.list-direct {
  position: relative;
}
.list-robo-employment {
  position: relative;
}
.list-robo {
  position: relative;
}
.list-setting {
  position: relative;
}
.list-operation {
  position: relative;
}
.list-info {
  position: relative;
}
.list-report {
  position: relative;
}
.dropdown-list {
  width: 200px;
  position: fixed;
  left: 210px;
  line-height:30px;
  background-color: #FEFEFE;
  border: 0.7px solid rgba(150, 140, 140, 0.8);
  box-shadow: 3px 3px 10px rgba(0,0,0,0.2);
  border-left: none;
  z-index: 10;
  a,.link {
    padding: 8px;
    border-radius: 2px;
    border-bottom: solid 0.7px rgba(150, 140, 140, 0.8);
  }
  a:hover,.link:hover {
    background-color:rgba(240, 200, 200, 0.8);
    color: #fff;
    cursor: pointer;
  }
  .icon {
    margin-right: 4px;
  }
}
.dropdown-list-mini {
  width: 200px;
  position: fixed;
  left: 50px;
  line-height:30px;
  background-color: #FEFEFE;
  border: 0.7px solid rgba(150, 140, 140, 0.8);
  box-shadow: 3px 3px 10px rgba(0,0,0,0.2);
  border-left: none;
  z-index: 10;
  a,.link {
    padding: 8px;
    border-radius: 2px;
    border-bottom: solid 0.7px rgba(150, 140, 140, 0.8);
  }
  a:hover,.link:hover {
    background-color:rgba(240, 200, 200, 0.8);
    color: #fff;
    cursor: pointer;
  }
  .icon {
    margin-right: 4px;
  }
}
.menu-list li ul {
    border-left: none;
    margin: 0;
    padding: 0;
}
.click-submenu {
  color: #fff;
  background: rgba(150, 140, 140, 0.8);
}
.account-img {
  width:  auto;
  height: 25px;
  border-radius: 50%;
  object-fit: cover;
  background: #fefefe;
  border: solid 2px #C82E42;
}
.no-viewing-permission-applicant {
  padding: 0.5em 0.75em;
}
.accordion-header {
  margin-top: 12px;
  margin-bottom: 4px;
  padding: 8px;
}
.accordion-header .hover-menu {
  padding: 0;
}
.accordion-header:hover .hover-menu {
  background-color: rgba(240, 200, 200, 0.8) !important;
}

.accordion-header.secondary {
  opacity: 0.7;
}

.accordion-header.secondary .hover-menu {
  font-size: 12px;
  color: rgba(255,255,255,0.8);
}

.accordion-header.secondary:hover .hover-menu {
  background-color: rgba(240, 200, 200, 0.6) !important;
  color: rgba(255,255,255,0.9);
}

.list-direct.secondary p {
  opacity: 0.7;
  font-size: 12px;
  color: rgba(255,255,255,0.8);
}

// ロボアイコン表示用スタイル
.robo-status-indicator {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.robo-icon-container {
  position: relative;
  display: inline-block;
  transition: transform 0.2s ease;
}
// 稼働中のロボアイコンのhover効果
.list-direct a:hover .robo-icon-container {
  transform: scale(1.1);
}

.robo-icon {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  padding: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  object-fit: contain;
  transition: box-shadow 0.2s ease;
}
.list-direct a:hover .robo-icon {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.robo-count-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  padding: 0 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border: 2px solid #ffffff;
}

// メニュー縮小時のスタイル調整
.custom-menu-min {
  .robo-status-indicator {
    padding: 8px;

    .robo-icon {
      width: 24px;
      height: 24px;
    }
  }
}

// ロボグリッドポップアップ
.robo-grid-popup {
  background-color: #ffffff;
  border: 1px solid rgba(150, 140, 140, 0.8);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  padding: 16px;
  backdrop-filter: blur(10px);
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

// ポップアップアニメーション
.robo-popup-fade-enter-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.robo-popup-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.robo-popup-fade-enter-from {
  opacity: 0;
  transform: scale(0.85) translateY(-10px);
}

.robo-popup-fade-leave-to {
  opacity: 0;
  transform: scale(0.95) translateY(-5px);
}

// グリッドコンテナ
.robo-grid-container {
  display: grid;
  gap: 8px;

  // 5台以下：横1行
  &.grid-single-row {
    grid-template-columns: repeat(auto-fit, 80px);
    grid-template-rows: 80px;
    max-width: 420px;
  }

  // 6台以上：3列グリッド
  &.grid-three-columns {
    grid-template-columns: repeat(3, 80px);
    grid-auto-rows: 80px;
    max-width: 260px;
    max-height: 260px;
  }
}

// グリッドアイテム
.robo-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f8f8f8;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: 1px solid transparent;
  transform: translateY(0);

  &:hover {
    background-color: #e8f4fd;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);
    border-color: rgba(0, 123, 255, 0.3);
    border-color: #4a90e2;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  // 「全て表示」ボタン
  &.more-item {
    background-color: #f0f0f0;
    border: 1px dashed #999;

    &:hover {
      background-color: #e0e0e0;
      border-color: #666;
    }
  }
}

// ロボアイコン（グリッド内）
.robo-grid-icon {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: #ffffff;
  padding: 4px;
  object-fit: contain;
  margin-bottom: 4px;
}

// ロボ名（グリッド内）
.robo-grid-name {
  font-size: 11px;
  line-height: 1.2;
  text-align: center;
  color: #333333;
  max-width: 72px;
  word-break: break-all;

  .more-count {
    font-size: 10px;
    color: #666666;
  }
}

// 「もっと見る」アイコン
.more-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/Client/ClientMainMenu.vue